export const ADULT_RATING_VALUE = 'adult';
export const RTA_LABEL = 'RTA-5042-1996-1400-1577-RTA';

export const MATURE_BESTICLE_SLUGS = new Set([
  'best-erotic-ai-chat-platforms',
  'best-dirty-talking-ai-chat-platforms',
  'best-nsfw-character-ai-alternatives',
  'best-nude-ai-chat-platforms',
  'best-ai-sex-story-generator-platforms',
  'best-ai-roleplay-chat-platforms',
]);

export const MATURE_HEAVENPEDIA_SLUGS = new Set([
  'nsfw',
  'ai-porn',
  'ai-sex',
  'ai-sexting',
  'dirty-talking-ai',
  'erotic-ai',
  'hentai-ai',
  'uncensored-ai',
]);

export function normalizePath(pathname: string): string {
  const noQuery = (pathname || '/').split('?')[0].split('#')[0];
  const withLeading = noQuery.startsWith('/') ? noQuery : `/${noQuery}`;
  if (withLeading.length > 1 && withLeading.endsWith('/')) {
    return withLeading.slice(0, -1);
  }
  return withLeading || '/';
}

export function pathRequiresAdultRating(pathname: string): boolean {
  const path = normalizePath(pathname);
  const bestMatch = path.match(/^\/best\/([^/]+)$/);
  if (bestMatch && MATURE_BESTICLE_SLUGS.has(bestMatch[1])) {
    return true;
  }

  const heavenpediaMatch = path.match(/^\/heavenpedia\/([^/]+)$/);
  if (heavenpediaMatch && MATURE_HEAVENPEDIA_SLUGS.has(heavenpediaMatch[1])) {
    return true;
  }

  return false;
}

/** RTA label for mature hubs and every individual review. The reviews index stays unlabeled. */
export function pathRequiresRtaLabel(pathname: string): boolean {
  if (pathRequiresAdultRating(pathname)) return true;
  return /^\/reviews\/[^/]+$/.test(normalizePath(pathname));
}

export function getAdultRatingMetadata() {
  return {
    other: {
      rating: [ADULT_RATING_VALUE, RTA_LABEL],
    },
  };
}

type MetadataLike = {
  other?: Record<string, string | number | Array<string | number>>;
  [key: string]: unknown;
};

export function mergeAdultRatingMetadata<T extends MetadataLike>(
  pathname: string,
  metadata: T
): T {
  if (!pathRequiresRtaLabel(pathname)) {
    return metadata;
  }

  return {
    ...metadata,
    other: {
      ...(metadata.other ?? {}),
      rating: [ADULT_RATING_VALUE, RTA_LABEL],
    },
  };
}
